
import { Card, Col, Container, Row, Spinner } from 'react-bootstrap';
import { StyledCardBody, StyledCardBodyOverflow, StyledCardHeader } from '../../components/dashboard/attentionPoints/styles';
import DashboardChart from '../../components/dashboard/chart';
import TableComponent from '../../components/dashboard/table';
import HeaderManager from '../../components/headerManager';
import SidebarResponsiveComp from '../../components/sideBar/siderbar-responsive';
import { CustomNav } from '../settings/styles';
import { ContainerDashboard, StyledCardIndicators } from './styles';
import AttentionPoints from '../../components/dashboard/attentionPoints';
import { useInsightsData } from './hooks/useInsightsData';
import InsightsFilters from './components/InsightsFilters/InsightsFilters';
import IndicatorsTable from './components/IndicatorsTable';
import DimensionChartsGrid from './components/DimensionChartsGrid';
import IfozEvolutionChart from './components/IfozEvolutionChart';
import IndicatorCards from './components/IndicatorCards';
import GroupParticipationReport from './components/GroupParticipationSummary/GroupParticipationSummary';
import { useTranslation } from 'react-i18next';

/**
 * Página de Insights.
 * Exibe gráficos e dados sobre o bem-estar dos colaboradores.
 * A lógica de busca e manipulação de dados é abstraída pelo hook `useInsightsData`.
 * Os filtros são renderizados pelo componente `InsightsFilters`.
 */
const Insights = () => {
    const { t } = useTranslation('insights');
    const {
        loading,
        loadingIndicators,
        loadingEpHistoric,
        loadingEngHistoric,
        loadingRelHistoric,
        loadingSigHistoric,
        loadingReaHistoric,
        loadingVitHistoric,
        loadingGroupParticipationReport,
        pageData,
        groupParticipationReportRows,
        dateValue,
        setDateValue,
        range,
        setRange,
        selectGroupOptions,
        representationSelectedOptions,
        setRepresentationSelectedOptions,
        selectedGroupOptions,
        setSelectedGroups,
        appliedRepresentationSelectedOptions,
        appliedGroupOptions,
        loadFilteredData,
        loadData,
        surveysAllMonth,
        companyCreatedAt
    } = useInsightsData();

    return (
        <>
            <SidebarResponsiveComp title={t('pageTitle')} />
            <HeaderManager title={t('pageTitle')} />
            <CustomNav className="mt-1" style={{ margin: '0', border: 'none' }} />

            <Container fluid className='d-flex flex-column' >

                <InsightsFilters
                    loading={loading}
                    loadingIndicators={loadingIndicators}
                    loadingEpHistoric={loadingEpHistoric}
                    loadingEngHistoric={loadingEngHistoric}
                    loadingRelHistoric={loadingRelHistoric}
                    loadingSigHistoric={loadingSigHistoric}
                    loadingReaHistoric={loadingReaHistoric}
                    loadingVitHistoric={loadingVitHistoric}
                    dateValue={dateValue}
                    setDateValue={setDateValue}
                    range={range}
                    setRange={setRange}
                    selectGroupOptions={selectGroupOptions}
                    representationSelectedOptions={representationSelectedOptions}
                    setRepresentationSelectedOptions={setRepresentationSelectedOptions}
                    selectedGroupOptions={selectedGroupOptions}
                    setSelectedGroups={setSelectedGroups}
                    loadFilteredData={loadFilteredData}
                    loadData={loadData}
                    surveysAllMonth={surveysAllMonth}
                />

                {loading ? (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '300px' }}>
                        <Spinner style={{ color: '#c9c9c9' }} />
                    </div>
                ) : (
                    <ContainerDashboard>
                        <IndicatorCards
                            pageData={pageData}
                            dateValue={dateValue}
                            representationSelectedOptions={appliedRepresentationSelectedOptions}
                            selectedGroupOptions={appliedGroupOptions}
                        />

                        <IfozEvolutionChart
                            generalData={pageData.ifozHistoric}
                            filteredData={pageData.filteredIfozHistoric}
                        />

                        <IndicatorsTable
                            loading={loadingIndicators}
                            ifozHistoric={pageData.filteredIfozHistoric.length > 0 ? pageData.filteredIfozHistoric : pageData.ifozHistoric}
                            iapHistoric={pageData.filteredIapHistoric.length > 0 ? pageData.filteredIapHistoric : pageData.ipaHistoric}
                            iepHistoric={pageData.filteredIepHistoric.length > 0 ? pageData.filteredIepHistoric : pageData.iepHistoric}
                            ifczHistoric={pageData.filteredIfczHistoric.length > 0 ? pageData.filteredIfczHistoric : pageData.ifczHistoric}
                            hasFilter={appliedRepresentationSelectedOptions?.length > 0 || appliedGroupOptions?.length > 0}
                            companyCreatedAt={companyCreatedAt}
                        />

                        <DimensionChartsGrid
                            pageData={pageData}
                            loadingEpHistoric={loadingEpHistoric}
                            loadingEngHistoric={loadingEngHistoric}
                            loadingRelHistoric={loadingRelHistoric}
                            loadingSigHistoric={loadingSigHistoric}
                            loadingReaHistoric={loadingReaHistoric}
                            loadingVitHistoric={loadingVitHistoric}
                        />

                        <GroupParticipationReport
                            loading={loadingGroupParticipationReport}
                            rows={groupParticipationReportRows}
                            range={range}
                            hasRepresentationFilter={appliedRepresentationSelectedOptions?.length > 0}
                        />
                    </ContainerDashboard>
                )}
            </Container>
        </>
    );
};

export default Insights;
